import './style.scss';
import {initArchiveFilterSearch} from "../../scripts/archive-filter-search";

export function gear_block() {
    initArchiveFilterSearch({
        root: '.gear_block',
        counterInputsSelector: 'input[type="checkbox"][name="application[]"]',
    });
}
